import { useRef, useCallback } from 'react'

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function useThrottle<T extends (...args: any[]) => any>(
  callback: T,
  delay: number,
): (...args: Parameters<T>) => void {
  const lastCalled = useRef(0)
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null)

  const throttledFunction = useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now()
      const remaining = delay - (now - lastCalled.current)

      if (remaining <= 0) {
        if (timeout.current) {
          clearTimeout(timeout.current)
          timeout.current = null
        }
        lastCalled.current = now
        callback(...args)
      } else if (!timeout.current) {
        timeout.current = setTimeout(() => {
          lastCalled.current = Date.now()
          timeout.current = null
          callback(...args)
        }, remaining)
      }
    },
    [callback, delay],
  )

  return throttledFunction
}
